<template>
  <div
    class="card shadow m-3 position-fixed right-0 top-0"
    style="z-index:1"
    data-test="progress-bar"
    v-show="showModal"
  >
    <div class="card-body d-flex align-items-center">
      <div
        :class="{'rotate': !complete}"
        class="mr-3 rounded-round d-flex align-items-center justify-content-center p-2 border-2 border-primary text-primary"
        style="width:50px; height:50px;"
      >
        <i class="fa-solid fa-hourglass-half fa-2x" />
      </div>

      <div >
        <div
          class="progress rounded-round mb-2"
          style="height:12px"
        >
          <div
            class="progress-bar bg-primary rounded-round"
            :style="`width:${progressBarWidth}%;`"
          >
            <!-- <span class="label-percent"></span> -->
          </div>
        </div>
        <div>
          <!-- กำลังยืนยันคำสั่งซื้อ 4 รายการจากทั้งหมด 50 รายการ -->
          {{ $t('Confirming {countConfirmOrder} out of {totalOrder} orders.') | replaceText(countConfirmOrder, totalOrder) }}
        </div>

        <div v-if="showLogError">
          <a
            href="#collapse-icon"
            class="collapsed font-size-sm text-default"
            data-toggle="collapse"
          >
            <span class="text-muted">
              {{ $t('Activity Logs Order') }}
            </span> 
            <i class="fa-regular fa-triangle-exclamation text-danger" />
          </a>
        </div>
      </div>
      <button
        :class="{'text-muted': !closeModal}"
        @click="confirmOrderSuccess()"
        type="button"
        class="close align-self-start ml-2 mr-n1 mt-n2"
      >
        <span>×</span>
      </button>
    </div>

    <div
      v-if="showLogError"
      style="max-width: 320px;"
    >
      <div
        class="collapse"
        id="collapse-icon"
      >
        <div
          v-if="listMsg"
          class="card-body border-left-warning border-left-2 pl-0 pt-0"
          style="max-height: 600px; overflow-x: hidden; overflow-y: auto;"
        >
          <ul class="list mb-0">
            <li
              v-for="(list, i) in listMsg"
              :key="'list'+i"
              class="font-size-sm mb-2"
              :class="{'text-danger': !list.status}"
            >
              <span v-if="list.status">({{ list.orderNumber }}) {{ list.message }}</span>
              <span v-else>({{ list.orderNumber }}) {{ list.message }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        const vm = this;
        return {
            closeModal: false,
            listMsg: [],
            totalOrder: 0,
            countConfirmOrder: 0,
            actionList: [],
            failAttempts: [],
            showLogError: false,
            showModal: false,
            intervalData: true
        }
    },
    computed: {
        progressBarWidth() {
            return this.countConfirmOrder * 100 / this.totalOrder;
        },
        complete() {
            return this.countConfirmOrder == this.totalOrder;
        }
    },
    methods: {
        confirmOrderSuccess() {
          if(!this.closeModal) return;
          this.$store.dispatch("order/isModalOrderConfirm", false);
        },
    },
    filters: {
        replaceText: function (text, countConfirmOrder, totalOrder) {
            text = text.replace('{totalOrder}', totalOrder);
            text = text.replace('{countConfirmOrder}', countConfirmOrder);
            return text;
        }
    },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/orders/ModalOrderConfirm.vue